import React, { useRef } from 'react';
import './style/product1.css';
import whatsappIcon from './assets/whatsapp.png';

import { product1, product2, product3 } from './assets/index';

const Product = () => {
    const productSectionRef = useRef(null);
    const form = useRef();

    const handleWhatsAppChat = () => {
        const phoneNumber = "+91 8511444442"; // Add country code (e.g., +91 for India) and remove spaces
        const message =
          "Hello! I want to inquire about your water filtration products.";
        window.open(
          `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`,
          "_blank"
        );
      };
      

    const sendEmail = async (e) => {
        e.preventDefault();
    
        // Collecting form data
        const formData = {
            user_name: e.target.user_name.value,  // Getting values from form inputs
            user_email: e.target.user_email.value,
            message: e.target.message.value,
        };
    
        try {
            // Sending the data to the PHP API
            const response = await fetch('https://techsoln.co.in/send-email.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
    
            // Checking if the response is successful
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json();
            if (data.status === 'success') {
                alert('Email sent successfully!');
                form.current.reset(); // Clear the form fields
            } else {
                alert(`Failed to send email: ${data.message}`);
            }
        } catch (error) {
            console.error('Error sending email:', error);
            alert('An error occurred while sending the email.');
        }
    };
    

    const products = [
        {
            src: product1,
            model: 'Model A',
            description: 'RO',
            mainColumns: ['CAPACITY', 'MEMBRANE', 'PUMP', 'MOC', 'PIPING', 'SYSTEM'],
            subColumns: [
                '250-50000 LPH',
                'TOREY/DOW/EQUI V.',
                'GRUNDFOS/KIRLOSKAR/EQUIV.',
                'M.S./S.S.',
                'UPVC/S.S./EQUIV.',
                'MANUAL/AUTO',
            ],
        },
        {
            src: product2,
            model: 'Model B',
            description: 'UF',
            mainColumns: ['CAPACITY', 'MEMBRANE', 'PUMP', 'MOC', 'PIPING', 'SYSTEM'],
            subColumns: [
                '250-50000 LPH',
                'TOREY/DOW/EQUI V.',
                'GRUNDFOS/KIRLOSKAR/EQUIV.',
                'M.S./S.S.',
                'UPVC/S.S./EQUIV.',
                'MANUAL/AUTO',
            ],
        },
        {
            src: product3,
            model: 'Model C',
            description: 'STPETP',
            mainColumns: ['CAPACITY', 'MEMBRANE', 'PUMP', 'MOC', 'PIPING', 'SYSTEM'],
            subColumns: [
                '250-50000 LPH',
                'TOREY/DOW/EQUI V.',
                'GRUNDFOS/KIRLOSKAR/EQUIV.',
                'M.S./S.S.',
                'UPVC/S.S./EQUIV.',
                'MANUAL/AUTO',
            ],
        },
    ];

    return (
        <div className="product-page">
            <header className="header">
                <h1>NEW PROJECT</h1>
            </header>

            <div className="whatsapp-icon" onClick={handleWhatsAppChat}>
                <img src={whatsappIcon} alt="WhatsApp" />
            </div>

            <section className="new-product-gallery" ref={productSectionRef}>
  <div className="new-section-header">
   
    {/* <button
      className="new-view-all-button"
      onClick={() => (window.location.href = "/product")}
    >
      View All
    </button> */}
  </div>
  <div className="new-product-list">
    {products.map((product, index) => (
      <div
        className="new-product-item"
        key={index}
        style={{ "--animation-order": index }}
      >
        <img src={product.src} alt={`Product ${product.model}`} />
        <h3>{product.description}</h3>
        <div className="new-columns-container">
          {/* Main Column */}
          <div className="new-main-column">
            {product.mainColumns.map((mainCol, i) => (
              <h6 key={`main-${i}`}>{mainCol}</h6>
            ))}
          </div>
          {/* Sub Column */}
          <div className="new-sub-column">
            {product.subColumns.map((subCol, i) => (
              <h6 key={`sub-${i}`}>{subCol}</h6>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
</section>

            <h1>PLANT EXPANSION & RETROFIT PROJECTS</h1>
            <section className="contact-section">
                <h2>Contact Us</h2>
                <form className="contact-form" ref={form} onSubmit={sendEmail}>
                    <div className="form-group">
                        <label htmlFor="name">Name</label>
                        <input type="text" name="user_name" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="email">Email</label>
                        <input type="email" name="user_email" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="message">Message</label>
                        <textarea id="message" name="message" required></textarea>
                    </div>
                    <button type="submit">
                        Send
                    </button>
                </form>
            </section>

            <footer className="footer">
  <div className="footer-content">
    <div className="footer-left">
      <h3>Techsoln</h3>
      <p>
        Your trusted partner in water filtration solutions. Providing
        customized, advanced water filtration systems since 2017.
      </p>
      <div className="social-links">
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <i className="fab fa-facebook"></i>
        </a>
        <a
          href="https://twitter.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Twitter"
        >
          <i className="fab fa-twitter"></i>
        </a>
        <a
          href="https://linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <i className="fab fa-linkedin"></i>
        </a>
        <a
          href="https://instagram.com"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <i className="fab fa-instagram"></i>
        </a>
      </div>
    </div>

    <div className="footer-middle">
      <h4>Quick Links</h4>
      <ul>
        <li><a href="/">Home</a></li>
        <li><a href="/About">About Us</a></li>
        <li><a href="/Product">Products</a></li>
      </ul>
    </div>

    <div className="footer-right">
      <h4>Contact Us</h4>
      <p><strong>Email:</strong> info@techsoln.co.in</p>
      <p><strong>Phone:</strong> +91 85114 44442</p>
      <p><strong>Address:</strong> TF-325, “S9 SQUARE”, Opp. Lotus Aura, Sama-Savli Road, Vadodara 390008, Gujarat, India</p>
    </div>
  </div>

  <div className="footer-bottom">
    <p>&copy; {new Date().getFullYear()} Techsoln. All rights reserved.</p>
  </div>
</footer>


        </div>
    );
};

export default Product;
